<template>
  <div>
    <Tree
      :data="treeData"
      @on-check-change="selectData"
      :render="renderContent"
      show-checkbox
    ></Tree>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      
      treeData: [],
      selected: {
        ids: [],
      },
    };
  },

  created: function () {
    this.selected.ids = this.currentData;
    this.getListTree();
  },

  methods: {
    getListTree() {
      
      this.$api.post("/client/gettree", this.selected).then((rsp) => {
        if (rsp != false) {
          this.treeData = rsp.data;
        }
      });
    },

    selectData: function (data) {
      //getCheckedNodes	获取被勾选的节点
      // getSelectedNodes	获取被选中的节点
      // getCheckedAndIndeterminateNodes	获取选中及半选节点
      this.$emit("selectTreeData", data);
    },

    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline",
              },
              style: {
                marginRight: "8px",
              },
            }),
            h("span", data.title),
          ]),
          h("span", {
            style: {
              display: "inline-block",
              float: "right",
              marginRight: "32px",
            },
          }),
        ]
      );
    },
  },
};
</script>
<style scoped>
</style>